import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c5710c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex header-content justify-content-between align-items-center" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "ml-s3 text-muted"
}
const _hoisted_4 = { class: "flex align-items-center gutter-x-s3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import LogoFull from '@/components/LogoFull.vue';
import Wallet from '../wallet/Wallet.vue';
import HeaderMobileMenu from '../menu/HeaderMobileMenu.vue';
import MainMenu from '../menu/MainMenu.vue';
import SpicePoints from '@/components/SpicePoints.vue';
import NetworkSelect from './NetworkSelect.vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { APP_NETWORK_NAME } from '@/helpers/networkParams.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { state } = useStore();
const headerRef = ref();
const route = useRoute();
const { t, te } = useI18n();

const routeToTitle = name => {
  return te(`mainMenu.${name.toString().charAt(0).toLowerCase() + name.toString().slice(1)}`)
    ? t(`mainMenu.${name.toString().charAt(0).toLowerCase() + name.toString().slice(1)}`)
    : '';
};

const pageTitle = computed(() => (route.name ? routeToTitle(route.name) : ''));
let scrollListener;
const bindScrollListener = () => {
  if (!scrollListener) {
    if (headerRef.value) {
      scrollListener = () => {
        if (window.scrollY > 0) headerRef.value.classList.add('header-sticky');
        else headerRef.value.classList.remove('header-sticky');
      };
    }
  }
  window.addEventListener('scroll', scrollListener);
};
const unbindScrollListener = () => {
  if (scrollListener) {
    window.removeEventListener('scroll', scrollListener);
    scrollListener = null;
  }
};

onMounted(() => bindScrollListener());
onBeforeUnmount(() => unbindScrollListener());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    id: "header",
    ref_key: "headerRef",
    ref: headerRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(LogoFull),
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(pageTitle)), 1))
          : _createCommentVNode("", true),
        (_unref(state).layout.isDesktop)
          ? (_openBlock(), _createBlock(MainMenu, {
              key: 1,
              class: "mr-auto ml-s5"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(SpicePoints)
            ]))
          : _createCommentVNode("", true),
        (!_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(NetworkSelect, { "current-network": _unref(APP_NETWORK_NAME) }, null, 8, ["current-network"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (!_unref(state).layout.isMobile)
            ? (_openBlock(), _createBlock(Wallet, {
                key: 0,
                ref: "wallet"
              }, null, 512))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (!_unref(state).layout.isDesktop)
            ? (_openBlock(), _createBlock(HeaderMobileMenu, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}
}

})